"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createJobStatusResponse = void 0;

var _listJobsResponse = require("./list-jobs-response");

var createJobStatusResponse = function createJobStatusResponse(raw) {
  var data = (0, _listJobsResponse.createJobListResponse)(raw);
  return {
    result: data.result,
    // This looks like a 404... TODO?
    response: data.returnedCount > 0 ? data.response[0] : undefined
  };
};

exports.createJobStatusResponse = createJobStatusResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/jobs/response-parsers/job-status-response.js
// module id = 226
// module chunks = 0